import type { SVGProps } from "react";
import * as React from "react";

const SvgBell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2V1zM6 8H5zm-3 9-.555-.832A1 1 0 0 0 3 18zm18 0v1a1 1 0 0 0 .555-1.832zm-6.405 4.502a1 1 0 0 0-1.73-1.004zm-3.46-1.004a1 1 0 0 0-1.73 1.004zM19 8a7 7 0 0 0-2.05-4.95l-1.414 1.414A5 5 0 0 1 17 8zm-2.05-4.95A7 7 0 0 0 12 1v2a5 5 0 0 1 3.536 1.464zM12 1a7 7 0 0 0-4.95 2.05l1.414 1.414A5 5 0 0 1 12 3zM7.05 3.05A7 7 0 0 0 5 8h2a5 5 0 0 1 1.464-3.536zM5 8c0 3.353-.717 5.435-1.378 6.646a6 6 0 0 1-.88 1.244 3 3 0 0 1-.305.284q-.006.004-.004.003l.004-.003.004-.003.002-.001.001-.001s.001-.001.556.831.555.832.556.831h.001l.004-.003.006-.005.064-.045q.055-.04.138-.11c.11-.092.257-.224.426-.402a8 8 0 0 0 1.183-1.662C6.218 14.065 7 11.647 7 8zM3 18h18v-2H3zm18-1c.555-.832.555-.832.556-.831h.001l.002.002.008.006q.002 0-.003-.003l-.053-.042a3 3 0 0 1-.254-.242 6 6 0 0 1-.88-1.244C19.718 13.435 19 11.353 19 8h-2c0 3.647.783 6.065 1.622 7.604a8 8 0 0 0 1.183 1.662 5 5 0 0 0 .564.512l.047.034.017.011.006.005q.003.001.003.002l.002.001s.001.001.556-.831m-8.135 3.498a1 1 0 0 1-.366.365l.998 1.733a3 3 0 0 0 1.098-1.094zm-.366.365a1 1 0 0 1-.499.134v2a3 3 0 0 0 1.497-.4zm-.499.134a1 1 0 0 1-.5-.134l-.997 1.733a3 3 0 0 0 1.497.4zm-.5-.134a1 1 0 0 1-.365-.365l-1.73 1.004a3 3 0 0 0 1.098 1.094z"
    />
  </svg>
);
export default SvgBell;
